/**
 * buysupply-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ActivityRequest', 'model/ActivityResponse', 'model/ApplicationRequest', 'model/ApplicationResponse', 'model/BusinessIndustryRequest', 'model/BusinessIndustryResponse', 'model/BusinessRequest', 'model/BusinessResponse', 'model/ComponentRequest', 'model/ComponentResponse', 'model/ConfigurationRequest', 'model/ConfigurationResponse', 'model/ContactRequest', 'model/ContactResponse', 'model/FormItemRequest', 'model/FormItemResponse', 'model/FormRequest', 'model/FormResponse', 'model/LoginRequest', 'model/LoginResponse', 'model/MatrixItemRequest', 'model/MatrixItemResponse', 'model/MatrixRequest', 'model/MatrixResponse', 'model/PdfRequest', 'model/PdfResponse', 'model/ProductRequest', 'model/ProductResponse', 'model/ProfileItemRequest', 'model/ProfileItemResponse', 'model/ProfileRequest', 'model/ProfileRequestRequest', 'model/ProfileRequestResponse', 'model/ProfileResponse', 'model/RegisterRequest', 'model/RegisterResponse', 'model/UserRequest', 'model/UserResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ActivityRequest'), require('../model/ActivityResponse'), require('../model/ApplicationRequest'), require('../model/ApplicationResponse'), require('../model/BusinessIndustryRequest'), require('../model/BusinessIndustryResponse'), require('../model/BusinessRequest'), require('../model/BusinessResponse'), require('../model/ComponentRequest'), require('../model/ComponentResponse'), require('../model/ConfigurationRequest'), require('../model/ConfigurationResponse'), require('../model/ContactRequest'), require('../model/ContactResponse'), require('../model/FormItemRequest'), require('../model/FormItemResponse'), require('../model/FormRequest'), require('../model/FormResponse'), require('../model/LoginRequest'), require('../model/LoginResponse'), require('../model/MatrixItemRequest'), require('../model/MatrixItemResponse'), require('../model/MatrixRequest'), require('../model/MatrixResponse'), require('../model/PdfRequest'), require('../model/PdfResponse'), require('../model/ProductRequest'), require('../model/ProductResponse'), require('../model/ProfileItemRequest'), require('../model/ProfileItemResponse'), require('../model/ProfileRequest'), require('../model/ProfileRequestRequest'), require('../model/ProfileRequestResponse'), require('../model/ProfileResponse'), require('../model/RegisterRequest'), require('../model/RegisterResponse'), require('../model/UserRequest'), require('../model/UserResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.BuysupplyProductionappspotcom) {
      root.BuysupplyProductionappspotcom = {};
    }
    root.BuysupplyProductionappspotcom.DefaultApi = factory(root.BuysupplyProductionappspotcom.ApiClient, root.BuysupplyProductionappspotcom.ActivityRequest, root.BuysupplyProductionappspotcom.ActivityResponse, root.BuysupplyProductionappspotcom.ApplicationRequest, root.BuysupplyProductionappspotcom.ApplicationResponse, root.BuysupplyProductionappspotcom.BusinessIndustryRequest, root.BuysupplyProductionappspotcom.BusinessIndustryResponse, root.BuysupplyProductionappspotcom.BusinessRequest, root.BuysupplyProductionappspotcom.BusinessResponse, root.BuysupplyProductionappspotcom.ComponentRequest, root.BuysupplyProductionappspotcom.ComponentResponse, root.BuysupplyProductionappspotcom.ConfigurationRequest, root.BuysupplyProductionappspotcom.ConfigurationResponse, root.BuysupplyProductionappspotcom.ContactRequest, root.BuysupplyProductionappspotcom.ContactResponse, root.BuysupplyProductionappspotcom.FormItemRequest, root.BuysupplyProductionappspotcom.FormItemResponse, root.BuysupplyProductionappspotcom.FormRequest, root.BuysupplyProductionappspotcom.FormResponse, root.BuysupplyProductionappspotcom.LoginRequest, root.BuysupplyProductionappspotcom.LoginResponse, root.BuysupplyProductionappspotcom.MatrixItemRequest, root.BuysupplyProductionappspotcom.MatrixItemResponse, root.BuysupplyProductionappspotcom.MatrixRequest, root.BuysupplyProductionappspotcom.MatrixResponse, root.BuysupplyProductionappspotcom.PdfRequest, root.BuysupplyProductionappspotcom.PdfResponse, root.BuysupplyProductionappspotcom.ProductRequest, root.BuysupplyProductionappspotcom.ProductResponse, root.BuysupplyProductionappspotcom.ProfileItemRequest, root.BuysupplyProductionappspotcom.ProfileItemResponse, root.BuysupplyProductionappspotcom.ProfileRequest, root.BuysupplyProductionappspotcom.ProfileRequestRequest, root.BuysupplyProductionappspotcom.ProfileRequestResponse, root.BuysupplyProductionappspotcom.ProfileResponse, root.BuysupplyProductionappspotcom.RegisterRequest, root.BuysupplyProductionappspotcom.RegisterResponse, root.BuysupplyProductionappspotcom.UserRequest, root.BuysupplyProductionappspotcom.UserResponse);
  }
}(this, function(ApiClient, ActivityRequest, ActivityResponse, ApplicationRequest, ApplicationResponse, BusinessIndustryRequest, BusinessIndustryResponse, BusinessRequest, BusinessResponse, ComponentRequest, ComponentResponse, ConfigurationRequest, ConfigurationResponse, ContactRequest, ContactResponse, FormItemRequest, FormItemResponse, FormRequest, FormResponse, LoginRequest, LoginResponse, MatrixItemRequest, MatrixItemResponse, MatrixRequest, MatrixResponse, PdfRequest, PdfResponse, ProductRequest, ProductResponse, ProfileItemRequest, ProfileItemResponse, ProfileRequest, ProfileRequestRequest, ProfileRequestResponse, ProfileResponse, RegisterRequest, RegisterResponse, UserRequest, UserResponse) {
  'use strict';

  /**
   * Default service.
   * @module api/DefaultApi
   * @version 1.0.0
   */

  /**
   * Constructs a new DefaultApi. 
   * @alias module:api/DefaultApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the activityApiV1ActivityCreate operation.
     * @callback module:api/DefaultApi~activityApiV1ActivityCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ActivityResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ActivityRequest} opts.body 
     * @param {module:api/DefaultApi~activityApiV1ActivityCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ActivityResponse}
     */
    this.activityApiV1ActivityCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ActivityResponse;

      return this.apiClient.callApi(
        '/activityApi/v1/activityCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the activityApiV1ActivityDelete operation.
     * @callback module:api/DefaultApi~activityApiV1ActivityDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ActivityResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ActivityRequest} opts.body 
     * @param {module:api/DefaultApi~activityApiV1ActivityDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ActivityResponse}
     */
    this.activityApiV1ActivityDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ActivityResponse;

      return this.apiClient.callApi(
        '/activityApi/v1/activityDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the activityApiV1ActivityGetByCodeTag operation.
     * @callback module:api/DefaultApi~activityApiV1ActivityGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ActivityResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ActivityRequest} opts.body 
     * @param {module:api/DefaultApi~activityApiV1ActivityGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ActivityResponse}
     */
    this.activityApiV1ActivityGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ActivityResponse;

      return this.apiClient.callApi(
        '/activityApi/v1/activityGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the activityApiV1ActivityGetById operation.
     * @callback module:api/DefaultApi~activityApiV1ActivityGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ActivityResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ActivityRequest} opts.body 
     * @param {module:api/DefaultApi~activityApiV1ActivityGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ActivityResponse}
     */
    this.activityApiV1ActivityGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ActivityResponse;

      return this.apiClient.callApi(
        '/activityApi/v1/activityGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the activityApiV1ActivityGetByType operation.
     * @callback module:api/DefaultApi~activityApiV1ActivityGetByTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ActivityResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ActivityRequest} opts.body 
     * @param {module:api/DefaultApi~activityApiV1ActivityGetByTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ActivityResponse}
     */
    this.activityApiV1ActivityGetByType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ActivityResponse;

      return this.apiClient.callApi(
        '/activityApi/v1/activityGetByType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the activityApiV1ActivityGetByViewedProfile operation.
     * @callback module:api/DefaultApi~activityApiV1ActivityGetByViewedProfileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ActivityResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ActivityRequest} opts.body 
     * @param {module:api/DefaultApi~activityApiV1ActivityGetByViewedProfileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ActivityResponse}
     */
    this.activityApiV1ActivityGetByViewedProfile = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ActivityResponse;

      return this.apiClient.callApi(
        '/activityApi/v1/activityGetByViewedProfile', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the activityApiV1ActivityUpdate operation.
     * @callback module:api/DefaultApi~activityApiV1ActivityUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ActivityResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ActivityRequest} opts.body 
     * @param {module:api/DefaultApi~activityApiV1ActivityUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ActivityResponse}
     */
    this.activityApiV1ActivityUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ActivityResponse;

      return this.apiClient.callApi(
        '/activityApi/v1/activityUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationCreate operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationCreateCsvFile operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationCreateCsvFileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationCreateCsvFileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationCreateCsvFile = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationCreateCsvFile', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationDelete operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationGetByApplicationType operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationGetByApplicationTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationGetByApplicationTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationGetByApplicationType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationGetByApplicationType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationGetByBuyerId operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationGetByBuyerIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationGetByBuyerIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationGetByBuyerId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationGetByBuyerId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationGetByBuyerIdFeedbackType operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationGetByBuyerIdFeedbackTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationGetByBuyerIdFeedbackTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationGetByBuyerIdFeedbackType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationGetByBuyerIdFeedbackType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationGetByCodeTag operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationGetByCodeTagAndFeedbackType operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationGetByCodeTagAndFeedbackTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationGetByCodeTagAndFeedbackTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationGetByCodeTagAndFeedbackType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationGetByCodeTagAndFeedbackType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationGetByCodeTagAndStatus operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationGetByCodeTagAndStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationGetByCodeTagAndStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationGetByCodeTagAndStatus = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationGetByCodeTagAndStatus', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationGetByFeedbackType operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationGetByFeedbackTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationGetByFeedbackTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationGetByFeedbackType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationGetByFeedbackType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationGetById operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationGetByPPEBusiness operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationGetByPPEBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationGetByPPEBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationGetByPPEBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationGetByPPEBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationGetByProductList operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationGetByProductListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationGetByProductListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationGetByProductList = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationGetByProductList', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationGetByStatus operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationGetByStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationGetByStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationGetByStatus = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationGetByStatus', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationListAll operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationListAllCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationListAllCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationListAll = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationListAll', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationRequestFeedback operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationRequestFeedbackCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationRequestFeedbackCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationRequestFeedback = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationRequestFeedback', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the applicationApiV1ApplicationUpdate operation.
     * @callback module:api/DefaultApi~applicationApiV1ApplicationUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApplicationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ApplicationRequest} opts.body 
     * @param {module:api/DefaultApi~applicationApiV1ApplicationUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ApplicationResponse}
     */
    this.applicationApiV1ApplicationUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ApplicationResponse;

      return this.apiClient.callApi(
        '/applicationApi/v1/applicationUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinessAccountGet operation.
     * @callback module:api/DefaultApi~businessApiV1BusinessAccountGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinessAccountGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinessAccountGet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businessAccountGet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinessCreateCsvFile operation.
     * @callback module:api/DefaultApi~businessApiV1BusinessCreateCsvFileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinessCreateCsvFileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinessCreateCsvFile = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businessCreateCsvFile', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinessListByPPEType operation.
     * @callback module:api/DefaultApi~businessApiV1BusinessListByPPETypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinessListByPPETypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinessListByPPEType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businessListByPPEType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinessUpdate operation.
     * @callback module:api/DefaultApi~businessApiV1BusinessUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinessUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinessUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businessUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinesslistAll operation.
     * @callback module:api/DefaultApi~businessApiV1BusinesslistAllCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinesslistAllCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinesslistAll = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businesslistAll', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinesslistByName operation.
     * @callback module:api/DefaultApi~businessApiV1BusinesslistByNameCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinesslistByNameCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinesslistByName = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businesslistByName', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinesslistByType operation.
     * @callback module:api/DefaultApi~businessApiV1BusinesslistByTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinesslistByTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinesslistByType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businesslistByType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinesslistInTown operation.
     * @callback module:api/DefaultApi~businessApiV1BusinesslistInTownCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinesslistInTownCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinesslistInTown = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businesslistInTown', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1CloseBusinessNow operation.
     * @callback module:api/DefaultApi~businessApiV1CloseBusinessNowCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1CloseBusinessNowCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1CloseBusinessNow = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/closeBusinessNow', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1CreateBusiness operation.
     * @callback module:api/DefaultApi~businessApiV1CreateBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1CreateBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1CreateBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/createBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1EraseBusiness operation.
     * @callback module:api/DefaultApi~businessApiV1EraseBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1EraseBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1EraseBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/eraseBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1LocationGet operation.
     * @callback module:api/DefaultApi~businessApiV1LocationGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1LocationGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1LocationGet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/locationGet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1LocationSet operation.
     * @callback module:api/DefaultApi~businessApiV1LocationSetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1LocationSetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1LocationSet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/locationSet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1OpenBusinessNow operation.
     * @callback module:api/DefaultApi~businessApiV1OpenBusinessNowCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1OpenBusinessNowCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1OpenBusinessNow = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/openBusinessNow', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1OpeningHoursGet operation.
     * @callback module:api/DefaultApi~businessApiV1OpeningHoursGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1OpeningHoursGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1OpeningHoursGet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/openingHoursGet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1OpeningHoursSet operation.
     * @callback module:api/DefaultApi~businessApiV1OpeningHoursSetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1OpeningHoursSetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1OpeningHoursSet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/openingHoursSet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessIndustryApiV1BusinessIndustryCreate operation.
     * @callback module:api/DefaultApi~businessIndustryApiV1BusinessIndustryCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessIndustryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessIndustryRequest} opts.body 
     * @param {module:api/DefaultApi~businessIndustryApiV1BusinessIndustryCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessIndustryResponse}
     */
    this.businessIndustryApiV1BusinessIndustryCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessIndustryResponse;

      return this.apiClient.callApi(
        '/businessIndustryApi/v1/businessIndustryCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessIndustryApiV1BusinessIndustryDelete operation.
     * @callback module:api/DefaultApi~businessIndustryApiV1BusinessIndustryDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessIndustryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessIndustryRequest} opts.body 
     * @param {module:api/DefaultApi~businessIndustryApiV1BusinessIndustryDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessIndustryResponse}
     */
    this.businessIndustryApiV1BusinessIndustryDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessIndustryResponse;

      return this.apiClient.callApi(
        '/businessIndustryApi/v1/businessIndustryDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessIndustryApiV1BusinessIndustryGetByCodeTag operation.
     * @callback module:api/DefaultApi~businessIndustryApiV1BusinessIndustryGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessIndustryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessIndustryRequest} opts.body 
     * @param {module:api/DefaultApi~businessIndustryApiV1BusinessIndustryGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessIndustryResponse}
     */
    this.businessIndustryApiV1BusinessIndustryGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessIndustryResponse;

      return this.apiClient.callApi(
        '/businessIndustryApi/v1/businessIndustryGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessIndustryApiV1BusinessIndustryGetById operation.
     * @callback module:api/DefaultApi~businessIndustryApiV1BusinessIndustryGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessIndustryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessIndustryRequest} opts.body 
     * @param {module:api/DefaultApi~businessIndustryApiV1BusinessIndustryGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessIndustryResponse}
     */
    this.businessIndustryApiV1BusinessIndustryGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessIndustryResponse;

      return this.apiClient.callApi(
        '/businessIndustryApi/v1/businessIndustryGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessIndustryApiV1BusinessIndustryGetByName operation.
     * @callback module:api/DefaultApi~businessIndustryApiV1BusinessIndustryGetByNameCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessIndustryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessIndustryRequest} opts.body 
     * @param {module:api/DefaultApi~businessIndustryApiV1BusinessIndustryGetByNameCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessIndustryResponse}
     */
    this.businessIndustryApiV1BusinessIndustryGetByName = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessIndustryResponse;

      return this.apiClient.callApi(
        '/businessIndustryApi/v1/businessIndustryGetByName', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessIndustryApiV1BusinessIndustryUpdate operation.
     * @callback module:api/DefaultApi~businessIndustryApiV1BusinessIndustryUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessIndustryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessIndustryRequest} opts.body 
     * @param {module:api/DefaultApi~businessIndustryApiV1BusinessIndustryUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessIndustryResponse}
     */
    this.businessIndustryApiV1BusinessIndustryUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessIndustryResponse;

      return this.apiClient.callApi(
        '/businessIndustryApi/v1/businessIndustryUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the componentApiV1ComponentCreate operation.
     * @callback module:api/DefaultApi~componentApiV1ComponentCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ComponentResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ComponentRequest} opts.body 
     * @param {module:api/DefaultApi~componentApiV1ComponentCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ComponentResponse}
     */
    this.componentApiV1ComponentCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ComponentResponse;

      return this.apiClient.callApi(
        '/componentApi/v1/componentCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the componentApiV1ComponentDelete operation.
     * @callback module:api/DefaultApi~componentApiV1ComponentDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ComponentResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ComponentRequest} opts.body 
     * @param {module:api/DefaultApi~componentApiV1ComponentDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ComponentResponse}
     */
    this.componentApiV1ComponentDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ComponentResponse;

      return this.apiClient.callApi(
        '/componentApi/v1/componentDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the componentApiV1ComponentGetByCodeTag operation.
     * @callback module:api/DefaultApi~componentApiV1ComponentGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ComponentResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ComponentRequest} opts.body 
     * @param {module:api/DefaultApi~componentApiV1ComponentGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ComponentResponse}
     */
    this.componentApiV1ComponentGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ComponentResponse;

      return this.apiClient.callApi(
        '/componentApi/v1/componentGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the componentApiV1ComponentGetById operation.
     * @callback module:api/DefaultApi~componentApiV1ComponentGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ComponentResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ComponentRequest} opts.body 
     * @param {module:api/DefaultApi~componentApiV1ComponentGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ComponentResponse}
     */
    this.componentApiV1ComponentGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ComponentResponse;

      return this.apiClient.callApi(
        '/componentApi/v1/componentGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the componentApiV1ComponentGetByName operation.
     * @callback module:api/DefaultApi~componentApiV1ComponentGetByNameCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ComponentResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ComponentRequest} opts.body 
     * @param {module:api/DefaultApi~componentApiV1ComponentGetByNameCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ComponentResponse}
     */
    this.componentApiV1ComponentGetByName = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ComponentResponse;

      return this.apiClient.callApi(
        '/componentApi/v1/componentGetByName', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the componentApiV1ComponentGetByType operation.
     * @callback module:api/DefaultApi~componentApiV1ComponentGetByTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ComponentResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ComponentRequest} opts.body 
     * @param {module:api/DefaultApi~componentApiV1ComponentGetByTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ComponentResponse}
     */
    this.componentApiV1ComponentGetByType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ComponentResponse;

      return this.apiClient.callApi(
        '/componentApi/v1/componentGetByType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the componentApiV1ComponentGetMatrixItems operation.
     * @callback module:api/DefaultApi~componentApiV1ComponentGetMatrixItemsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ComponentResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ComponentRequest} opts.body 
     * @param {module:api/DefaultApi~componentApiV1ComponentGetMatrixItemsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ComponentResponse}
     */
    this.componentApiV1ComponentGetMatrixItems = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ComponentResponse;

      return this.apiClient.callApi(
        '/componentApi/v1/componentGetMatrixItems', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the componentApiV1ComponentUpdate operation.
     * @callback module:api/DefaultApi~componentApiV1ComponentUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ComponentResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ComponentRequest} opts.body 
     * @param {module:api/DefaultApi~componentApiV1ComponentUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ComponentResponse}
     */
    this.componentApiV1ComponentUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ComponentResponse;

      return this.apiClient.callApi(
        '/componentApi/v1/componentUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1ConfigUpdateBoolean operation.
     * @callback module:api/DefaultApi~configurationApiV1ConfigUpdateBooleanCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1ConfigUpdateBooleanCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1ConfigUpdateBoolean = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/configUpdateBoolean', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1ConfigUpdateInt operation.
     * @callback module:api/DefaultApi~configurationApiV1ConfigUpdateIntCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1ConfigUpdateIntCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1ConfigUpdateInt = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/configUpdateInt', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1ConfigUpdateString operation.
     * @callback module:api/DefaultApi~configurationApiV1ConfigUpdateStringCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1ConfigUpdateStringCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1ConfigUpdateString = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/configUpdateString', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1DumpConfig operation.
     * @callback module:api/DefaultApi~configurationApiV1DumpConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1DumpConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1DumpConfig = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/dumpConfig', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1ReloadConfig operation.
     * @callback module:api/DefaultApi~configurationApiV1ReloadConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1ReloadConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1ReloadConfig = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/reloadConfig', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1StoreConfig operation.
     * @callback module:api/DefaultApi~configurationApiV1StoreConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1StoreConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1StoreConfig = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/storeConfig', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the contactApiV1ContactCreate operation.
     * @callback module:api/DefaultApi~contactApiV1ContactCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContactResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ContactRequest} opts.body 
     * @param {module:api/DefaultApi~contactApiV1ContactCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContactResponse}
     */
    this.contactApiV1ContactCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ContactResponse;

      return this.apiClient.callApi(
        '/contactApi/v1/contactCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the contactApiV1ContactDelete operation.
     * @callback module:api/DefaultApi~contactApiV1ContactDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContactResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ContactRequest} opts.body 
     * @param {module:api/DefaultApi~contactApiV1ContactDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContactResponse}
     */
    this.contactApiV1ContactDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ContactResponse;

      return this.apiClient.callApi(
        '/contactApi/v1/contactDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the contactApiV1ContactGetByCodeTag operation.
     * @callback module:api/DefaultApi~contactApiV1ContactGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContactResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ContactRequest} opts.body 
     * @param {module:api/DefaultApi~contactApiV1ContactGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContactResponse}
     */
    this.contactApiV1ContactGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ContactResponse;

      return this.apiClient.callApi(
        '/contactApi/v1/contactGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the contactApiV1ContactGetByCodeTagAndContactedBusiness operation.
     * @callback module:api/DefaultApi~contactApiV1ContactGetByCodeTagAndContactedBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContactResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ContactRequest} opts.body 
     * @param {module:api/DefaultApi~contactApiV1ContactGetByCodeTagAndContactedBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContactResponse}
     */
    this.contactApiV1ContactGetByCodeTagAndContactedBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ContactResponse;

      return this.apiClient.callApi(
        '/contactApi/v1/contactGetByCodeTagAndContactedBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the contactApiV1ContactGetByContactedBusiness operation.
     * @callback module:api/DefaultApi~contactApiV1ContactGetByContactedBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContactResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ContactRequest} opts.body 
     * @param {module:api/DefaultApi~contactApiV1ContactGetByContactedBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContactResponse}
     */
    this.contactApiV1ContactGetByContactedBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ContactResponse;

      return this.apiClient.callApi(
        '/contactApi/v1/contactGetByContactedBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the contactApiV1ContactGetById operation.
     * @callback module:api/DefaultApi~contactApiV1ContactGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContactResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ContactRequest} opts.body 
     * @param {module:api/DefaultApi~contactApiV1ContactGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContactResponse}
     */
    this.contactApiV1ContactGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ContactResponse;

      return this.apiClient.callApi(
        '/contactApi/v1/contactGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the contactApiV1ContactUpdate operation.
     * @callback module:api/DefaultApi~contactApiV1ContactUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContactResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ContactRequest} opts.body 
     * @param {module:api/DefaultApi~contactApiV1ContactUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContactResponse}
     */
    this.contactApiV1ContactUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ContactResponse;

      return this.apiClient.callApi(
        '/contactApi/v1/contactUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the formApiV1FormCreate operation.
     * @callback module:api/DefaultApi~formApiV1FormCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FormResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FormRequest} opts.body 
     * @param {module:api/DefaultApi~formApiV1FormCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FormResponse}
     */
    this.formApiV1FormCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FormResponse;

      return this.apiClient.callApi(
        '/formApi/v1/formCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the formApiV1FormDelete operation.
     * @callback module:api/DefaultApi~formApiV1FormDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FormResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FormRequest} opts.body 
     * @param {module:api/DefaultApi~formApiV1FormDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FormResponse}
     */
    this.formApiV1FormDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FormResponse;

      return this.apiClient.callApi(
        '/formApi/v1/formDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the formApiV1FormGetByCodeTag operation.
     * @callback module:api/DefaultApi~formApiV1FormGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FormResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FormRequest} opts.body 
     * @param {module:api/DefaultApi~formApiV1FormGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FormResponse}
     */
    this.formApiV1FormGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FormResponse;

      return this.apiClient.callApi(
        '/formApi/v1/formGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the formApiV1FormGetById operation.
     * @callback module:api/DefaultApi~formApiV1FormGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FormResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FormRequest} opts.body 
     * @param {module:api/DefaultApi~formApiV1FormGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FormResponse}
     */
    this.formApiV1FormGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FormResponse;

      return this.apiClient.callApi(
        '/formApi/v1/formGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the formApiV1FormGetByType operation.
     * @callback module:api/DefaultApi~formApiV1FormGetByTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FormResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FormRequest} opts.body 
     * @param {module:api/DefaultApi~formApiV1FormGetByTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FormResponse}
     */
    this.formApiV1FormGetByType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FormResponse;

      return this.apiClient.callApi(
        '/formApi/v1/formGetByType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the formApiV1FormUpdate operation.
     * @callback module:api/DefaultApi~formApiV1FormUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FormResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FormRequest} opts.body 
     * @param {module:api/DefaultApi~formApiV1FormUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FormResponse}
     */
    this.formApiV1FormUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FormResponse;

      return this.apiClient.callApi(
        '/formApi/v1/formUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the formItemApiV1FormItemCreate operation.
     * @callback module:api/DefaultApi~formItemApiV1FormItemCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FormItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FormItemRequest} opts.body 
     * @param {module:api/DefaultApi~formItemApiV1FormItemCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FormItemResponse}
     */
    this.formItemApiV1FormItemCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FormItemResponse;

      return this.apiClient.callApi(
        '/formItemApi/v1/formItemCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the formItemApiV1FormItemDelete operation.
     * @callback module:api/DefaultApi~formItemApiV1FormItemDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FormItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FormItemRequest} opts.body 
     * @param {module:api/DefaultApi~formItemApiV1FormItemDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FormItemResponse}
     */
    this.formItemApiV1FormItemDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FormItemResponse;

      return this.apiClient.callApi(
        '/formItemApi/v1/formItemDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the formItemApiV1FormItemGetByCodeTag operation.
     * @callback module:api/DefaultApi~formItemApiV1FormItemGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FormItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FormItemRequest} opts.body 
     * @param {module:api/DefaultApi~formItemApiV1FormItemGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FormItemResponse}
     */
    this.formItemApiV1FormItemGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FormItemResponse;

      return this.apiClient.callApi(
        '/formItemApi/v1/formItemGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the formItemApiV1FormItemGetByFormId operation.
     * @callback module:api/DefaultApi~formItemApiV1FormItemGetByFormIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FormItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FormItemRequest} opts.body 
     * @param {module:api/DefaultApi~formItemApiV1FormItemGetByFormIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FormItemResponse}
     */
    this.formItemApiV1FormItemGetByFormId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FormItemResponse;

      return this.apiClient.callApi(
        '/formItemApi/v1/formItemGetByFormId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the formItemApiV1FormItemGetById operation.
     * @callback module:api/DefaultApi~formItemApiV1FormItemGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FormItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FormItemRequest} opts.body 
     * @param {module:api/DefaultApi~formItemApiV1FormItemGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FormItemResponse}
     */
    this.formItemApiV1FormItemGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FormItemResponse;

      return this.apiClient.callApi(
        '/formItemApi/v1/formItemGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the formItemApiV1FormItemGetByUserId operation.
     * @callback module:api/DefaultApi~formItemApiV1FormItemGetByUserIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FormItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FormItemRequest} opts.body 
     * @param {module:api/DefaultApi~formItemApiV1FormItemGetByUserIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FormItemResponse}
     */
    this.formItemApiV1FormItemGetByUserId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FormItemResponse;

      return this.apiClient.callApi(
        '/formItemApi/v1/formItemGetByUserId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the formItemApiV1FormItemUpdate operation.
     * @callback module:api/DefaultApi~formItemApiV1FormItemUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FormItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FormItemRequest} opts.body 
     * @param {module:api/DefaultApi~formItemApiV1FormItemUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FormItemResponse}
     */
    this.formItemApiV1FormItemUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FormItemResponse;

      return this.apiClient.callApi(
        '/formItemApi/v1/formItemUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the loginApiV1Login operation.
     * @callback module:api/DefaultApi~loginApiV1LoginCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LoginResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LoginRequest} opts.body 
     * @param {module:api/DefaultApi~loginApiV1LoginCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LoginResponse}
     */
    this.loginApiV1Login = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LoginResponse;

      return this.apiClient.callApi(
        '/loginApi/v1/login', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the loginApiV1LoginListBusinesses operation.
     * @callback module:api/DefaultApi~loginApiV1LoginListBusinessesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LoginResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LoginRequest} opts.body 
     * @param {module:api/DefaultApi~loginApiV1LoginListBusinessesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LoginResponse}
     */
    this.loginApiV1LoginListBusinesses = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LoginResponse;

      return this.apiClient.callApi(
        '/loginApi/v1/loginListBusinesses', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixApiV1MatrixCreate operation.
     * @callback module:api/DefaultApi~matrixApiV1MatrixCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixRequest} opts.body 
     * @param {module:api/DefaultApi~matrixApiV1MatrixCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixResponse}
     */
    this.matrixApiV1MatrixCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixResponse;

      return this.apiClient.callApi(
        '/matrixApi/v1/matrixCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixApiV1MatrixDelete operation.
     * @callback module:api/DefaultApi~matrixApiV1MatrixDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixRequest} opts.body 
     * @param {module:api/DefaultApi~matrixApiV1MatrixDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixResponse}
     */
    this.matrixApiV1MatrixDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixResponse;

      return this.apiClient.callApi(
        '/matrixApi/v1/matrixDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixApiV1MatrixGetByArchivedAndMatrixType operation.
     * @callback module:api/DefaultApi~matrixApiV1MatrixGetByArchivedAndMatrixTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixRequest} opts.body 
     * @param {module:api/DefaultApi~matrixApiV1MatrixGetByArchivedAndMatrixTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixResponse}
     */
    this.matrixApiV1MatrixGetByArchivedAndMatrixType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixResponse;

      return this.apiClient.callApi(
        '/matrixApi/v1/matrixGetByArchivedAndMatrixType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixApiV1MatrixGetByCodeTag operation.
     * @callback module:api/DefaultApi~matrixApiV1MatrixGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixRequest} opts.body 
     * @param {module:api/DefaultApi~matrixApiV1MatrixGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixResponse}
     */
    this.matrixApiV1MatrixGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixResponse;

      return this.apiClient.callApi(
        '/matrixApi/v1/matrixGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixApiV1MatrixGetById operation.
     * @callback module:api/DefaultApi~matrixApiV1MatrixGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixRequest} opts.body 
     * @param {module:api/DefaultApi~matrixApiV1MatrixGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixResponse}
     */
    this.matrixApiV1MatrixGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixResponse;

      return this.apiClient.callApi(
        '/matrixApi/v1/matrixGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixApiV1MatrixGetByMatrixType operation.
     * @callback module:api/DefaultApi~matrixApiV1MatrixGetByMatrixTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixRequest} opts.body 
     * @param {module:api/DefaultApi~matrixApiV1MatrixGetByMatrixTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixResponse}
     */
    this.matrixApiV1MatrixGetByMatrixType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixResponse;

      return this.apiClient.callApi(
        '/matrixApi/v1/matrixGetByMatrixType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixApiV1MatrixGetMostRecentByType operation.
     * @callback module:api/DefaultApi~matrixApiV1MatrixGetMostRecentByTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixRequest} opts.body 
     * @param {module:api/DefaultApi~matrixApiV1MatrixGetMostRecentByTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixResponse}
     */
    this.matrixApiV1MatrixGetMostRecentByType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixResponse;

      return this.apiClient.callApi(
        '/matrixApi/v1/matrixGetMostRecentByType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixApiV1MatrixUpdate operation.
     * @callback module:api/DefaultApi~matrixApiV1MatrixUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixRequest} opts.body 
     * @param {module:api/DefaultApi~matrixApiV1MatrixUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixResponse}
     */
    this.matrixApiV1MatrixUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixResponse;

      return this.apiClient.callApi(
        '/matrixApi/v1/matrixUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixItemApiV1MatrixItemCreate operation.
     * @callback module:api/DefaultApi~matrixItemApiV1MatrixItemCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixItemRequest} opts.body 
     * @param {module:api/DefaultApi~matrixItemApiV1MatrixItemCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixItemResponse}
     */
    this.matrixItemApiV1MatrixItemCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixItemResponse;

      return this.apiClient.callApi(
        '/matrixItemApi/v1/matrixItemCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixItemApiV1MatrixItemDelete operation.
     * @callback module:api/DefaultApi~matrixItemApiV1MatrixItemDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixItemRequest} opts.body 
     * @param {module:api/DefaultApi~matrixItemApiV1MatrixItemDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixItemResponse}
     */
    this.matrixItemApiV1MatrixItemDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixItemResponse;

      return this.apiClient.callApi(
        '/matrixItemApi/v1/matrixItemDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixItemApiV1MatrixItemGetByArea operation.
     * @callback module:api/DefaultApi~matrixItemApiV1MatrixItemGetByAreaCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixItemRequest} opts.body 
     * @param {module:api/DefaultApi~matrixItemApiV1MatrixItemGetByAreaCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixItemResponse}
     */
    this.matrixItemApiV1MatrixItemGetByArea = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixItemResponse;

      return this.apiClient.callApi(
        '/matrixItemApi/v1/matrixItemGetByArea', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixItemApiV1MatrixItemGetByBusinessType operation.
     * @callback module:api/DefaultApi~matrixItemApiV1MatrixItemGetByBusinessTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixItemRequest} opts.body 
     * @param {module:api/DefaultApi~matrixItemApiV1MatrixItemGetByBusinessTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixItemResponse}
     */
    this.matrixItemApiV1MatrixItemGetByBusinessType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixItemResponse;

      return this.apiClient.callApi(
        '/matrixItemApi/v1/matrixItemGetByBusinessType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixItemApiV1MatrixItemGetByCodeTag operation.
     * @callback module:api/DefaultApi~matrixItemApiV1MatrixItemGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixItemRequest} opts.body 
     * @param {module:api/DefaultApi~matrixItemApiV1MatrixItemGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixItemResponse}
     */
    this.matrixItemApiV1MatrixItemGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixItemResponse;

      return this.apiClient.callApi(
        '/matrixItemApi/v1/matrixItemGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixItemApiV1MatrixItemGetByComponentId operation.
     * @callback module:api/DefaultApi~matrixItemApiV1MatrixItemGetByComponentIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixItemRequest} opts.body 
     * @param {module:api/DefaultApi~matrixItemApiV1MatrixItemGetByComponentIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixItemResponse}
     */
    this.matrixItemApiV1MatrixItemGetByComponentId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixItemResponse;

      return this.apiClient.callApi(
        '/matrixItemApi/v1/matrixItemGetByComponentId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixItemApiV1MatrixItemGetByComponentIdAndCodeTag operation.
     * @callback module:api/DefaultApi~matrixItemApiV1MatrixItemGetByComponentIdAndCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixItemRequest} opts.body 
     * @param {module:api/DefaultApi~matrixItemApiV1MatrixItemGetByComponentIdAndCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixItemResponse}
     */
    this.matrixItemApiV1MatrixItemGetByComponentIdAndCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixItemResponse;

      return this.apiClient.callApi(
        '/matrixItemApi/v1/matrixItemGetByComponentIdAndCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixItemApiV1MatrixItemGetById operation.
     * @callback module:api/DefaultApi~matrixItemApiV1MatrixItemGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixItemRequest} opts.body 
     * @param {module:api/DefaultApi~matrixItemApiV1MatrixItemGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixItemResponse}
     */
    this.matrixItemApiV1MatrixItemGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixItemResponse;

      return this.apiClient.callApi(
        '/matrixItemApi/v1/matrixItemGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixItemApiV1MatrixItemListAll operation.
     * @callback module:api/DefaultApi~matrixItemApiV1MatrixItemListAllCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixItemRequest} opts.body 
     * @param {module:api/DefaultApi~matrixItemApiV1MatrixItemListAllCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixItemResponse}
     */
    this.matrixItemApiV1MatrixItemListAll = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixItemResponse;

      return this.apiClient.callApi(
        '/matrixItemApi/v1/matrixItemListAll', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the matrixItemApiV1MatrixItemUpdate operation.
     * @callback module:api/DefaultApi~matrixItemApiV1MatrixItemUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MatrixItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MatrixItemRequest} opts.body 
     * @param {module:api/DefaultApi~matrixItemApiV1MatrixItemUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MatrixItemResponse}
     */
    this.matrixItemApiV1MatrixItemUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MatrixItemResponse;

      return this.apiClient.callApi(
        '/matrixItemApi/v1/matrixItemUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the pdfApiV1PdfCreateMatrix operation.
     * @callback module:api/DefaultApi~pdfApiV1PdfCreateMatrixCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PdfResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PdfRequest} opts.body 
     * @param {module:api/DefaultApi~pdfApiV1PdfCreateMatrixCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PdfResponse}
     */
    this.pdfApiV1PdfCreateMatrix = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PdfResponse;

      return this.apiClient.callApi(
        '/pdfApi/v1/pdfCreateMatrix', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductCreate operation.
     * @callback module:api/DefaultApi~productApiV1ProductCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductCreateCsvFile operation.
     * @callback module:api/DefaultApi~productApiV1ProductCreateCsvFileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductCreateCsvFileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductCreateCsvFile = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productCreateCsvFile', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductDelete operation.
     * @callback module:api/DefaultApi~productApiV1ProductDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductGetByCodeTag operation.
     * @callback module:api/DefaultApi~productApiV1ProductGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductGetByCodeTagAndType operation.
     * @callback module:api/DefaultApi~productApiV1ProductGetByCodeTagAndTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductGetByCodeTagAndTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductGetByCodeTagAndType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productGetByCodeTagAndType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductGetByComponentList operation.
     * @callback module:api/DefaultApi~productApiV1ProductGetByComponentListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductGetByComponentListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductGetByComponentList = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productGetByComponentList', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductGetById operation.
     * @callback module:api/DefaultApi~productApiV1ProductGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductGetByType operation.
     * @callback module:api/DefaultApi~productApiV1ProductGetByTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductGetByTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductGetByType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productGetByType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductMultipleCreate operation.
     * @callback module:api/DefaultApi~productApiV1ProductMultipleCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductMultipleCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductMultipleCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productMultipleCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductUpdate operation.
     * @callback module:api/DefaultApi~productApiV1ProductUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductUpdateDetails operation.
     * @callback module:api/DefaultApi~productApiV1ProductUpdateDetailsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductUpdateDetailsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductUpdateDetails = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productUpdateDetails', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileApiV1ProfileCreate operation.
     * @callback module:api/DefaultApi~profileApiV1ProfileCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequest} opts.body 
     * @param {module:api/DefaultApi~profileApiV1ProfileCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileResponse}
     */
    this.profileApiV1ProfileCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileResponse;

      return this.apiClient.callApi(
        '/profileApi/v1/profileCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileApiV1ProfileCreateCsvFile operation.
     * @callback module:api/DefaultApi~profileApiV1ProfileCreateCsvFileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequest} opts.body 
     * @param {module:api/DefaultApi~profileApiV1ProfileCreateCsvFileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileResponse}
     */
    this.profileApiV1ProfileCreateCsvFile = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileResponse;

      return this.apiClient.callApi(
        '/profileApi/v1/profileCreateCsvFile', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileApiV1ProfileDelete operation.
     * @callback module:api/DefaultApi~profileApiV1ProfileDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequest} opts.body 
     * @param {module:api/DefaultApi~profileApiV1ProfileDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileResponse}
     */
    this.profileApiV1ProfileDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileResponse;

      return this.apiClient.callApi(
        '/profileApi/v1/profileDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileApiV1ProfileGetByCodeTag operation.
     * @callback module:api/DefaultApi~profileApiV1ProfileGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequest} opts.body 
     * @param {module:api/DefaultApi~profileApiV1ProfileGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileResponse}
     */
    this.profileApiV1ProfileGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileResponse;

      return this.apiClient.callApi(
        '/profileApi/v1/profileGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileApiV1ProfileGetByComponentId operation.
     * @callback module:api/DefaultApi~profileApiV1ProfileGetByComponentIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequest} opts.body 
     * @param {module:api/DefaultApi~profileApiV1ProfileGetByComponentIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileResponse}
     */
    this.profileApiV1ProfileGetByComponentId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileResponse;

      return this.apiClient.callApi(
        '/profileApi/v1/profileGetByComponentId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileApiV1ProfileGetByFormId operation.
     * @callback module:api/DefaultApi~profileApiV1ProfileGetByFormIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequest} opts.body 
     * @param {module:api/DefaultApi~profileApiV1ProfileGetByFormIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileResponse}
     */
    this.profileApiV1ProfileGetByFormId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileResponse;

      return this.apiClient.callApi(
        '/profileApi/v1/profileGetByFormId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileApiV1ProfileGetById operation.
     * @callback module:api/DefaultApi~profileApiV1ProfileGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequest} opts.body 
     * @param {module:api/DefaultApi~profileApiV1ProfileGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileResponse}
     */
    this.profileApiV1ProfileGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileResponse;

      return this.apiClient.callApi(
        '/profileApi/v1/profileGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileApiV1ProfileGetByProfileStatus operation.
     * @callback module:api/DefaultApi~profileApiV1ProfileGetByProfileStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequest} opts.body 
     * @param {module:api/DefaultApi~profileApiV1ProfileGetByProfileStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileResponse}
     */
    this.profileApiV1ProfileGetByProfileStatus = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileResponse;

      return this.apiClient.callApi(
        '/profileApi/v1/profileGetByProfileStatus', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileApiV1ProfileGetByType operation.
     * @callback module:api/DefaultApi~profileApiV1ProfileGetByTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequest} opts.body 
     * @param {module:api/DefaultApi~profileApiV1ProfileGetByTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileResponse}
     */
    this.profileApiV1ProfileGetByType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileResponse;

      return this.apiClient.callApi(
        '/profileApi/v1/profileGetByType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileApiV1ProfileGetByTypeAndComponentId operation.
     * @callback module:api/DefaultApi~profileApiV1ProfileGetByTypeAndComponentIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequest} opts.body 
     * @param {module:api/DefaultApi~profileApiV1ProfileGetByTypeAndComponentIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileResponse}
     */
    this.profileApiV1ProfileGetByTypeAndComponentId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileResponse;

      return this.apiClient.callApi(
        '/profileApi/v1/profileGetByTypeAndComponentId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileApiV1ProfileListAll operation.
     * @callback module:api/DefaultApi~profileApiV1ProfileListAllCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequest} opts.body 
     * @param {module:api/DefaultApi~profileApiV1ProfileListAllCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileResponse}
     */
    this.profileApiV1ProfileListAll = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileResponse;

      return this.apiClient.callApi(
        '/profileApi/v1/profileListAll', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileApiV1ProfileUpdate operation.
     * @callback module:api/DefaultApi~profileApiV1ProfileUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequest} opts.body 
     * @param {module:api/DefaultApi~profileApiV1ProfileUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileResponse}
     */
    this.profileApiV1ProfileUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileResponse;

      return this.apiClient.callApi(
        '/profileApi/v1/profileUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileApiV1RegisterPPEBusiness operation.
     * @callback module:api/DefaultApi~profileApiV1RegisterPPEBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequest} opts.body 
     * @param {module:api/DefaultApi~profileApiV1RegisterPPEBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileResponse}
     */
    this.profileApiV1RegisterPPEBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileResponse;

      return this.apiClient.callApi(
        '/profileApi/v1/registerPPEBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileItemApiV1ProfileItemCreate operation.
     * @callback module:api/DefaultApi~profileItemApiV1ProfileItemCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileItemRequest} opts.body 
     * @param {module:api/DefaultApi~profileItemApiV1ProfileItemCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileItemResponse}
     */
    this.profileItemApiV1ProfileItemCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileItemResponse;

      return this.apiClient.callApi(
        '/profileItemApi/v1/profileItemCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileItemApiV1ProfileItemDelete operation.
     * @callback module:api/DefaultApi~profileItemApiV1ProfileItemDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileItemRequest} opts.body 
     * @param {module:api/DefaultApi~profileItemApiV1ProfileItemDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileItemResponse}
     */
    this.profileItemApiV1ProfileItemDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileItemResponse;

      return this.apiClient.callApi(
        '/profileItemApi/v1/profileItemDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileItemApiV1ProfileItemGetByCodeTag operation.
     * @callback module:api/DefaultApi~profileItemApiV1ProfileItemGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileItemRequest} opts.body 
     * @param {module:api/DefaultApi~profileItemApiV1ProfileItemGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileItemResponse}
     */
    this.profileItemApiV1ProfileItemGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileItemResponse;

      return this.apiClient.callApi(
        '/profileItemApi/v1/profileItemGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileItemApiV1ProfileItemGetByFormId operation.
     * @callback module:api/DefaultApi~profileItemApiV1ProfileItemGetByFormIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileItemRequest} opts.body 
     * @param {module:api/DefaultApi~profileItemApiV1ProfileItemGetByFormIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileItemResponse}
     */
    this.profileItemApiV1ProfileItemGetByFormId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileItemResponse;

      return this.apiClient.callApi(
        '/profileItemApi/v1/profileItemGetByFormId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileItemApiV1ProfileItemGetByFormItemId operation.
     * @callback module:api/DefaultApi~profileItemApiV1ProfileItemGetByFormItemIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileItemRequest} opts.body 
     * @param {module:api/DefaultApi~profileItemApiV1ProfileItemGetByFormItemIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileItemResponse}
     */
    this.profileItemApiV1ProfileItemGetByFormItemId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileItemResponse;

      return this.apiClient.callApi(
        '/profileItemApi/v1/profileItemGetByFormItemId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileItemApiV1ProfileItemGetById operation.
     * @callback module:api/DefaultApi~profileItemApiV1ProfileItemGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileItemRequest} opts.body 
     * @param {module:api/DefaultApi~profileItemApiV1ProfileItemGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileItemResponse}
     */
    this.profileItemApiV1ProfileItemGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileItemResponse;

      return this.apiClient.callApi(
        '/profileItemApi/v1/profileItemGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileItemApiV1ProfileItemGetByProfileId operation.
     * @callback module:api/DefaultApi~profileItemApiV1ProfileItemGetByProfileIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileItemRequest} opts.body 
     * @param {module:api/DefaultApi~profileItemApiV1ProfileItemGetByProfileIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileItemResponse}
     */
    this.profileItemApiV1ProfileItemGetByProfileId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileItemResponse;

      return this.apiClient.callApi(
        '/profileItemApi/v1/profileItemGetByProfileId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileItemApiV1ProfileItemGetByUserId operation.
     * @callback module:api/DefaultApi~profileItemApiV1ProfileItemGetByUserIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileItemRequest} opts.body 
     * @param {module:api/DefaultApi~profileItemApiV1ProfileItemGetByUserIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileItemResponse}
     */
    this.profileItemApiV1ProfileItemGetByUserId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileItemResponse;

      return this.apiClient.callApi(
        '/profileItemApi/v1/profileItemGetByUserId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileItemApiV1ProfileItemUpdate operation.
     * @callback module:api/DefaultApi~profileItemApiV1ProfileItemUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileItemRequest} opts.body 
     * @param {module:api/DefaultApi~profileItemApiV1ProfileItemUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileItemResponse}
     */
    this.profileItemApiV1ProfileItemUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileItemResponse;

      return this.apiClient.callApi(
        '/profileItemApi/v1/profileItemUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileRequestApiV1ProfileRequestCreate operation.
     * @callback module:api/DefaultApi~profileRequestApiV1ProfileRequestCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileRequestResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequestRequest} opts.body 
     * @param {module:api/DefaultApi~profileRequestApiV1ProfileRequestCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileRequestResponse}
     */
    this.profileRequestApiV1ProfileRequestCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileRequestResponse;

      return this.apiClient.callApi(
        '/profileRequestApi/v1/profileRequestCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileRequestApiV1ProfileRequestDelete operation.
     * @callback module:api/DefaultApi~profileRequestApiV1ProfileRequestDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileRequestResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequestRequest} opts.body 
     * @param {module:api/DefaultApi~profileRequestApiV1ProfileRequestDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileRequestResponse}
     */
    this.profileRequestApiV1ProfileRequestDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileRequestResponse;

      return this.apiClient.callApi(
        '/profileRequestApi/v1/profileRequestDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileRequestApiV1ProfileRequestGetByCodeTag operation.
     * @callback module:api/DefaultApi~profileRequestApiV1ProfileRequestGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileRequestResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequestRequest} opts.body 
     * @param {module:api/DefaultApi~profileRequestApiV1ProfileRequestGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileRequestResponse}
     */
    this.profileRequestApiV1ProfileRequestGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileRequestResponse;

      return this.apiClient.callApi(
        '/profileRequestApi/v1/profileRequestGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileRequestApiV1ProfileRequestGetByCodeTagAndSupplierId operation.
     * @callback module:api/DefaultApi~profileRequestApiV1ProfileRequestGetByCodeTagAndSupplierIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileRequestResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequestRequest} opts.body 
     * @param {module:api/DefaultApi~profileRequestApiV1ProfileRequestGetByCodeTagAndSupplierIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileRequestResponse}
     */
    this.profileRequestApiV1ProfileRequestGetByCodeTagAndSupplierId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileRequestResponse;

      return this.apiClient.callApi(
        '/profileRequestApi/v1/profileRequestGetByCodeTagAndSupplierId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileRequestApiV1ProfileRequestGetById operation.
     * @callback module:api/DefaultApi~profileRequestApiV1ProfileRequestGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileRequestResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequestRequest} opts.body 
     * @param {module:api/DefaultApi~profileRequestApiV1ProfileRequestGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileRequestResponse}
     */
    this.profileRequestApiV1ProfileRequestGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileRequestResponse;

      return this.apiClient.callApi(
        '/profileRequestApi/v1/profileRequestGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileRequestApiV1ProfileRequestGetByProfileRequestStatus operation.
     * @callback module:api/DefaultApi~profileRequestApiV1ProfileRequestGetByProfileRequestStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileRequestResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequestRequest} opts.body 
     * @param {module:api/DefaultApi~profileRequestApiV1ProfileRequestGetByProfileRequestStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileRequestResponse}
     */
    this.profileRequestApiV1ProfileRequestGetByProfileRequestStatus = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileRequestResponse;

      return this.apiClient.callApi(
        '/profileRequestApi/v1/profileRequestGetByProfileRequestStatus', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileRequestApiV1ProfileRequestGetBySupplierId operation.
     * @callback module:api/DefaultApi~profileRequestApiV1ProfileRequestGetBySupplierIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileRequestResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequestRequest} opts.body 
     * @param {module:api/DefaultApi~profileRequestApiV1ProfileRequestGetBySupplierIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileRequestResponse}
     */
    this.profileRequestApiV1ProfileRequestGetBySupplierId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileRequestResponse;

      return this.apiClient.callApi(
        '/profileRequestApi/v1/profileRequestGetBySupplierId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the profileRequestApiV1ProfileRequestUpdate operation.
     * @callback module:api/DefaultApi~profileRequestApiV1ProfileRequestUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProfileRequestResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProfileRequestRequest} opts.body 
     * @param {module:api/DefaultApi~profileRequestApiV1ProfileRequestUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProfileRequestResponse}
     */
    this.profileRequestApiV1ProfileRequestUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProfileRequestResponse;

      return this.apiClient.callApi(
        '/profileRequestApi/v1/profileRequestUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the registerApiV1RegisterCreate operation.
     * @callback module:api/DefaultApi~registerApiV1RegisterCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RegisterResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RegisterRequest} opts.body 
     * @param {module:api/DefaultApi~registerApiV1RegisterCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RegisterResponse}
     */
    this.registerApiV1RegisterCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = RegisterResponse;

      return this.apiClient.callApi(
        '/registerApi/v1/registerCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the registerApiV1RegisterGetEnums operation.
     * @callback module:api/DefaultApi~registerApiV1RegisterGetEnumsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RegisterResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RegisterRequest} opts.body 
     * @param {module:api/DefaultApi~registerApiV1RegisterGetEnumsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RegisterResponse}
     */
    this.registerApiV1RegisterGetEnums = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = RegisterResponse;

      return this.apiClient.callApi(
        '/registerApi/v1/registerGetEnums', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserAuthenticate operation.
     * @callback module:api/DefaultApi~userApiV1UserAuthenticateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserAuthenticateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserAuthenticate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userAuthenticate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserCreate operation.
     * @callback module:api/DefaultApi~userApiV1UserCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserCreateGlobal operation.
     * @callback module:api/DefaultApi~userApiV1UserCreateGlobalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserCreateGlobalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserCreateGlobal = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userCreateGlobal', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserDelete operation.
     * @callback module:api/DefaultApi~userApiV1UserDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserDeleteGlobal operation.
     * @callback module:api/DefaultApi~userApiV1UserDeleteGlobalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserDeleteGlobalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserDeleteGlobal = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userDeleteGlobal', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserGetAccount operation.
     * @callback module:api/DefaultApi~userApiV1UserGetAccountCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserGetAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserGetAccount = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userGetAccount', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserGetAccountGlobal operation.
     * @callback module:api/DefaultApi~userApiV1UserGetAccountGlobalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserGetAccountGlobalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserGetAccountGlobal = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userGetAccountGlobal', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserGetByEmail operation.
     * @callback module:api/DefaultApi~userApiV1UserGetByEmailCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserGetByEmailCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserGetByEmail = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userGetByEmail', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserListByRoleType operation.
     * @callback module:api/DefaultApi~userApiV1UserListByRoleTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserListByRoleTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserListByRoleType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userListByRoleType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserListInBusiness operation.
     * @callback module:api/DefaultApi~userApiV1UserListInBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserListInBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserListInBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userListInBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserListInBusinessGlobal operation.
     * @callback module:api/DefaultApi~userApiV1UserListInBusinessGlobalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserListInBusinessGlobalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserListInBusinessGlobal = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userListInBusinessGlobal', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserUpdateAccount operation.
     * @callback module:api/DefaultApi~userApiV1UserUpdateAccountCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserUpdateAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserUpdateAccount = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userUpdateAccount', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserUpdateAccountGlobal operation.
     * @callback module:api/DefaultApi~userApiV1UserUpdateAccountGlobalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserUpdateAccountGlobalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserUpdateAccountGlobal = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userUpdateAccountGlobal', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
